import { fetchGraphQL, fetchGeneral, fetchReport } from '../Connections';

import {
  getFieldListString
} from './util';

export function queryListFacilities(options, fields) {
  const query = `query listFacilities {
    listFacilities {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query });
}


export function queryGetFacility(variables, fields) {
  const query = `query getFacility($facility_id: String!) {
    getFacility(facility_id: $facility_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryGetFacilitySettings(variables, fields) {
  const query = `query getFacilitySettings($facility_id: String!) {
    getFacilitySettings(facility_id: $facility_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryGetFacilityPaymentTypes(variables, fields) {
  const query = `query getFacilityPaymentTypes($facilityId: String!) {
    getFacilityPaymentTypes(facilityId: $facilityId) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query, variables });
}

export function mutateUpdateFacilityPaymentTypes(variables, fields) {
  const mutation = `mutation updateFacilityPaymentTypes($facilityId: String!, $paymentTypes: [String]!) {
    updateFacilityPaymentTypes(facilityId: $facilityId, paymentTypes: $paymentTypes) {
      ${getFieldListString(fields)}
    }
  }`

  return fetchGraphQL({ query: mutation, variables });
}

export function queryCreateFacilitySettings(variables, fields) {
  const query = `mutation createFacilitySettings($facility_settings: FacilitySettingsInput!) {
    createFacilitySettings(facility_settings: $facility_settings) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryGetPaymentApplicationMonths(variables, fields) {
  const query = `query getPaymentApplicationMonths($facility_id: String!) {
    getPaymentApplicationMonths(facility_id: $facility_id) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryUpdateFacilitySettings(variables, fields) {
  const query = `mutation updateFacilitySettings($facility_settings: FacilitySettingsInput!) {
    updateFacilitySettings(facility_settings: $facility_settings) {
      ${getFieldListString(fields)}
    }
  }`;

  return fetchGraphQL({ query, variables });
}

export function queryGetBalanceReport(options) {
  return fetchGeneral('/balance_report', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryGetBalanceReportPdf(options) {
  return fetchGeneral('/balance_report_pdf', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryGetBalanceSummaryReportPdf(options) {
  return fetchGeneral('/balance_summary_pdf', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryGetReport(body) {
  return fetchReport({
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export function queryGetBalanceSummaryReport(options) {
  return fetchGeneral('/balance_summary_report', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}

export function queryGetSignUpTerminationReport(options) {
  return fetchGeneral('/signup_termination_report', {
    method: 'POST',
    body: JSON.stringify(options)
  });
}
